/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_TranslationInputs */

const en_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Translation`)
};

const fr_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer la traduction`)
};

const de_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung aktivieren`)
};

const it_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita traduzione`)
};

const ru_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить перевод`)
};

const es_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar traducción`)
};

const zh_cn2_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用翻译`)
};

const ja_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳を有効にする`)
};

const hi_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद सक्षम करें`)
};

const pt_pt2_enable_translation = /** @type {(inputs: Enable_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar tradução`)
};

/**
* | output |
* | --- |
* | "Enable Translation" |
*
* @param {Enable_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_translation = /** @type {((inputs?: Enable_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_enable_translation(inputs)
	if (locale === "de") return de_enable_translation(inputs)
	if (locale === "it") return it_enable_translation(inputs)
	if (locale === "ru") return ru_enable_translation(inputs)
	if (locale === "es") return es_enable_translation(inputs)
	if (locale === "zh-CN") return zh_cn2_enable_translation(inputs)
	if (locale === "ja") return ja_enable_translation(inputs)
	if (locale === "hi") return hi_enable_translation(inputs)
	if (locale === "pt-PT") return pt_pt2_enable_translation(inputs)
	return en_enable_translation(inputs)
});